// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        id: "prod_OHSayEKfN87zZ8",
        name: "LACRM Max Plan",
        active: true,
        metadata: {
            chat: "true",
            gbm: "true",
            partner: "lacrm",
            search: "true",
            sku: "LACRM MAX",
        },
        description:
            "AI powered chat, intelligent search, and GBM solutions integrated with the LACRM platform.  Includes enhanced reporting",
    },
    {
        id: "prod_LvOf7w0GnjgUGv",
        name: "Surfer Network 7 Net New (6/2022)",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_JYAW4sd4q6hsch",
        name: "Surfer Network 2 New (5/2021)",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_JQNH0WqWNOfnqy",
        name: "Monthly License and Management Fee @ $49/month/station (2 Stations)",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HogiC9BDaWtkbn",
        name: "KFNX News Talk Radio (Surfer Network) - 1st Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HoghYkYiHFZfep",
        name: "Globecom Media (Surfer Network) - Additional Skills",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HoghEI7v0dRCzK",
        name: "Globecom Media (Surfer Network) - 1st Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_Hogg6QCAYMLIdJ",
        name: "E-Communications (Surfer Network) - 2nd Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HoggHVrBtFHgsC",
        name: "E-Communications LLC (Surfer Network) - 1st Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_Hogfm1nApNm2mN",
        name: "American Urban Radio Networks (Surfer Network) - 1st Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HogeIqTXUtZytV",
        name: "Manhattan Broadcasting (Surfer Network) - Additional Skills",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_Hogd3O2KQsITTD",
        name: "Manhattan Broadcasting (Surfer Network) - 1st Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HogcOPhv7361aa",
        name: "Surfer Network - 1st Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_HF4ivNjXTgQKP9",
        name: "Surfer Network - 2nd Skill",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_FSBfTm01qsycQh",
        name: "Podcast Discount - Cincinnati Public Radio",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_F1w9lK5a4MgVr7",
        name: "Silas DISCOUNT Podcast Tier 1",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_EelT3BllNyLDGh",
        name: "Monthly Management Service Fee for Skills",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_EAoFti1csAMuWD",
        name: "Xapp Qrtly managed service fee-4 stations JackFM",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_E3zsRAJGdBzOP2",
        name: "Silas Video Skill - DISCOUNT",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_Dn5V5YuHnpnHvs",
        name: "Podcast - Hearst Custom Discount",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_DlgiCRJjPMXSfB",
        name: "Monthly Management Service fee  for Skill Apps",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_DgNl5dzoChou28",
        name: "Monthly Management Service fee  for Skill Apps",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_DYUP73p9lFWvrl",
        name: "Sound of Life - DISCOUNTED",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_D8JyhDIvfZtYQ1",
        name: "Big Radio Monthly Subscription (CUSTOM)",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_D5OtFHbhhEjE2k",
        name: "License and Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_D0ntheBvmUwlRj",
        name: "License and Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_Czm26X4aIBN7Kn",
        name: "License and Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CegbQJ7CyYfwyR",
        name: "11 LoveSport Podcast Alexa/Google Skills ACTUAL",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_Cefrr6aJc2FaFQ",
        name: "11 LoveSport Podcast Alexa/Google Skills",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CeP3P3GH7Srihy",
        name: "11 LoveSport Podcast Alexa/Google Skills",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CZWXuKkj6ROEWd",
        name: "Love Sport CUSTOM",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CUB3K9J1GPVkcR",
        name: "Jack Media - CUSTOM",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CMqMQ93XTSlL5s",
        name: "Podcast Tier 1",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CJp1sBJRGZiBjI",
        name: "Podcast Tier 1",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CJp0AEUj3PbuI3",
        name: "Podcast Tier 2",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CJp0X23mxrHaiL",
        name: "Podcast Tier Free",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_CBSwViKRMOlhiE",
        name: "Live From MIA - CUSTOM",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_C8sO9PTVMG0W2p",
        name: "ADX Custom",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_C4UgxHSdPZZJms",
        name: "License and Management Fee-KEGK FM",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_C48JdCZzYhR5Bk",
        name: "License and Management Fee-Fargo",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BoRnsOhdF1YnHG",
        name: "Voice Radio Pro - 2 Stations",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BVcfzWX4C0BVCP",
        name: "Live Stream Tier1 Discounted Annual",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BV1bx45h2OT2Wq",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BV1AT2PYNFTkSA",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BV0X7wbZNQKI4t",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BUjTmLDvz74SiZ",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BUTd22FcYbtHzY",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTgS9uqsJhFwvp",
        name: "Live Stream Tier 1 Discounted",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTXuzKBWXXSFIm",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTXpAyiMj9gB3Y",
        name: "License & Management Fee",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTN56hsHa430Er",
        name: "Live Stream Sub Tier 2",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTN46Al2WD18lP",
        name: "Live Stream Tier 2",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTN4dCY9gqRdMC",
        name: "Live Stream Sub Tier 1",
        active: true,
        metadata: {},
        description: null,
    },
    {
        id: "prod_BTN4fMPY9DeGuP",
        name: "Live Stream Tier 1",
        active: true,
        metadata: {},
        description: null,
    },
];
